import { SPEECH_MODELS, SPEECH_VOICES } from '../../lib/managedSpeech';

export const SpeechSettings = ({ settings, onChange, disabled, testId }) => (
  <fieldset className="speech-settings" disabled={disabled} data-testid={`${testId}-settings`}>
    <legend className="sr-only">Speech settings</legend>
    <label htmlFor={`${testId}-model`}>Model
      <select id={`${testId}-model`} data-testid={`${testId}-model`} value={settings.model}
        onChange={(e) => onChange({ ...settings, model: e.target.value })}>
        {SPEECH_MODELS.map((model) => <option key={model} value={model} data-testid={`${testId}-model-${model}`}>
          {model === 'tts-1' ? 'Standard · tts-1' : 'High definition · tts-1-hd'}
        </option>)}
      </select>
    </label>
    <label htmlFor={`${testId}-voice`}>Voice
      <select id={`${testId}-voice`} data-testid={`${testId}-voice`} value={settings.voice}
        onChange={(e) => onChange({ ...settings, voice: e.target.value })}>
        {SPEECH_VOICES.map((voice) => <option key={voice} value={voice} data-testid={`${testId}-voice-${voice}`}>
          {voice.charAt(0).toUpperCase() + voice.slice(1)}
        </option>)}
      </select>
    </label>
    <label htmlFor={`${testId}-speed`}>Speed <output data-testid={`${testId}-speed-value`}>{settings.speed.toFixed(2)}×</output>
      <input type="range" id={`${testId}-speed`} data-testid={`${testId}-speed`} min="0.25" max="4" step="0.25"
        value={settings.speed} onChange={(e) => onChange({ ...settings, speed: Number(e.target.value) })} />
    </label>
  </fieldset>
);